export default "__VITE_ASSET__7d8c83d3__"